_ = require 'underscore'
BaseDirectoryView = require './base-directory-view'
directoryLegacyPowerUps = require './directory-legacy-power-ups'
DirectoryPluginItemView = require './directory-plugin-item-view'
Format = require 'app/scripts/lib/markdown/format'
l = require 'app/scripts/lib/localize'
PluginIOCache = require 'app/scripts/views/internal/plugins/plugin-io-cache'
{ PowerUpItemType } = require 'app/common/components/power-up'
recupWithHelpers = require('app/scripts/views/internal/recup-with-helpers')
t = recupWithHelpers('directory')
powerUpItemDetailsT = recupWithHelpers('power_up_item_details')
c = recupWithHelpers('directory_data_consent')
notCompliantIcon = require 'resources/images/directory/icons/notCompliant.svg'
compliantIcon = require 'resources/images/directory/icons/compliant.svg'
React = require 'react'
xtend = require 'xtend'
{ featureFlagClient } = require '@trello/feature-flag-client'
pluginValidators = require 'app/scripts/lib/plugins/plugin-validators'

class DirectoryListing extends React.Component
  displayName: 'Directory Listing'

  render: t.renderable ->
    { supportEmail, description, displayName, isGrandfathered, isCompliant, privacyPolicy, categories, onCategoryClick, showSupportEmail } = @props

    t.div '.directory-individual-listing', ->
      t.div '.js-directory-listing'
      if showSupportEmail && supportEmail
        t.div '.directory-listing-support', ->
          t.div '.support-list', ->
            t.icon 'email', class: 'icon-lg'
            t.a '.support-link', { href: "mailto:#{supportEmail}?subject=#{displayName}" }, ->
              t.format 'contact-support'
            if pluginValidators.isValidHttp(privacyPolicy)
              t.icon 'information', class: 'icon-lg'
              t.a '.support-link', { href: privacyPolicy }, ->
                t.format 'privacy-policy'
      else
        t.div '.directory-listing-categories', ->
          t.icon 'information', class: 'icon-lg'
          t.div '.categories-list', ->
            _.map categories, (category) ->
              t.a '.category-link', { href: '#', onClick: -> onCategoryClick(category) }, ->
                t.format category

      if isGrandfathered
        t.p '.power-up-grandfathered', ->
          powerUpItemDetailsT.format 'power-up-was-enabled-on-this-board-before-some-recent-changes-we-made', {
            name: displayName
          }
          t.text ' 🎉'
      t.div '.directory-listing-content.markeddown', ->
        t.raw Format.markdownAsHtml(description)
      t.div '.directory-listing-compliance', ->
        src = if isCompliant == false then notCompliantIcon else compliantIcon

        c.img '.directory-listing-compliance-icon', { src, alt: "", role: "presentation" }
        if isCompliant == false
          c.format 'power-up-does-not-comply-with-our-data-privacy-standards', { pluginName: displayName }
        else if isCompliant == true
          c.format 'power-up-stores-data-complies-with-our-data-privacy-standards', { pluginName: displayName }
        else
          c.format 'power-up-complies-with-our-data-privacy-standards', { pluginName: displayName }

module.exports = class DirectoryListingView extends BaseDirectoryView
  className: 'directory-listing-wrapper'
  eventSource: ->'powerUpDetailsScreen'

  initialize: ({ @directoryView, @plugin, @currentPage }) ->
    super

    @supportEmailFlag = featureFlagClient.get('ecosystem.plugin-support-email', false)

    powerUp = _.findWhere directoryLegacyPowerUps, { id: @plugin.id }

    if powerUp
      name = powerUp.name
      @isGrandfathered = name in @model.get('powerUps')

  navigateToCategory: (category) ->
    @directoryView.navigate({ section: 'category', category })

  renderContent: ->
    io = PluginIOCache.get(@plugin)
    React.createElement DirectoryListing, {
      displayName: io.getName()
      description: io.getDescription()
      supportEmail: @plugin.get('supportEmail')
      privacyPolicy: @plugin.get('privacyUrl')
      categories: @plugin.get('categories')
      isGrandfathered: @isGrandfathered
      onCategoryClick: (category) => @navigateToCategory(category)
      isCompliant: @plugin.get('isCompliantWithPrivacyStandards')
      showSupportEmail: @supportEmailFlag
    }

  render: ->
    super

    @appendSubview @subview(DirectoryPluginItemView, @model, {
      atomType: PowerUpItemType.Listing
      @plugin,
      @currentPage,
      @directoryView,
    }, @plugin.id),
    @$('.js-directory-listing')

    enabledPlugins = @directoryView.getEnabledPlugins()

    @directoryView.trackScreenEvent @eventSource(),
      powerUpId: @plugin.id
      isEnabled: if _.some(enabledPlugins, { id: @plugin.id } ) then true else false

    @

